import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDndUpd = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 36,
	viewBox: "0 0 20 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 7,
			cy: 12,
			r: 1.5,
			fill: "#E8E8EC"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 13,
			cy: 12,
			r: 1.5,
			fill: "#E8E8EC"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 7,
			cy: 18,
			r: 1.5,
			fill: "#E8E8EC"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 13,
			cy: 18,
			r: 1.5,
			fill: "#E8E8EC"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 7,
			cy: 24,
			r: 1.5,
			fill: "#E8E8EC"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 13,
			cy: 24,
			r: 1.5,
			fill: "#E8E8EC"
		})
	]
});
const ForwardRef = forwardRef(SvgDndUpd);
export { ForwardRef as ReactComponent };
